import { render, staticRenderFns } from "./RiskyEventsCard.vue?vue&type=template&id=eaa3e0d4&"
import script from "./RiskyEventsCard.vue?vue&type=script&lang=ts&"
export * from "./RiskyEventsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports